import React, { createContext, useState, useEffect, useContext } from 'react';
import commonApi from '../utils/api';
import { CommonContext } from './CommonContext';

export const TaskMasterContext = createContext();

const initialFilters = {
    searchBy: 'task_master',
    searchValue: '',
    status: '',
};

export function TaskMasterContextProvider({ children }) {
    const { user, setModalAlert, setOpenAlert, setAlertMessage, setSeverity } = useContext(CommonContext);

    const [addModal, setAddModal] = useState(false);
    const [allData, setAllData] = useState([]);
    const [taskList, setTaskList] = useState([]);
    const [viewData, setViewData] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [isLoading, setIsLoading] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [selected, setSelected] = useState([]);
    const [filters, setFilters] = useState(initialFilters);

    const handleAddModal = () => {
        setAddModal(true);
        setModalAlert(false);
        setOpenAlert(false);
        setAlertMessage('');
        setSeverity('');
    };

    const handleCloseModal = () => {
        setViewData('')
        setIsEdit(false);
        setAddModal(false);
    };

    const onLoadApi = (customFilters = filters) => {
        let payload = {
            ...customFilters,
            admin_id: user?.id
        };

        setTaskList([]);
        setAllData([]);
        setFirstLoading(false);
        commonApi.post(`/users/task-master/list?page=${page + 1}&per_page=${rowsPerPage}`, payload)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setTaskList(response?.data?.data);
                    setAllData(response?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    const viewDetail = (id) => {
        setIsLoading(true);
        // Assuming there's a view endpoint or we can find it in the list
        // Since user didn't specify /view, I'll check if list has enough info or if there's a standard pattern
        // Usually it's /users/task-master/view or similar. 
        // For now, I'll use the taskList to find the item or try calling a view API.
        const task = taskList.find(t => t.id === id);
        if (task) {
            setViewData(task);
            setIsEdit(true);
            handleAddModal();
            setIsLoading(false);
        } else {
            // Try API if not in list (though usually it is)
            commonApi.post('/users/task-master/view', { id: id, admin_id: user?.id })
                .then((response) => {
                    setIsLoading(false);
                    if (response?.data?.data) {
                        setIsEdit(true);
                        setViewData(response?.data?.data);
                        handleAddModal();
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    console.error('Error fetching data:', error);
                });
        }
    }

    useEffect(() => {
        onLoadApi();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, rowsPerPage]);

    const contextValue = {
        filters,
        setFilters,
        initialFilters,
        viewDetail,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        selected,
        setSelected,
        isEdit,
        onLoadApi,
        isLoading,
        firstLoading,
        viewData,
        taskList,
        allData,
        handleAddModal,
        handleCloseModal,
        setAddModal,
        addModal,
        setAllData,
        setTaskList,
        setViewData,
        setFirstLoading,
        setIsLoading,
        setIsEdit,
    };

    return <TaskMasterContext.Provider value={contextValue}>{children}</TaskMasterContext.Provider>;
}
